import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty, isNil, isNull } from 'lodash'
import axios from 'axios'
import { Modal, Icon, Table, Avatar } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../../utils/hooks'
import { fetchHeroPromoteDetail } from '../../../modules/heroPromote'
import { HERO_TYPE_MESSAGE } from '../../../utils/constants'
import Lightbox from "react-image-lightbox";
import "../../../../node_modules/react-image-lightbox/style.css";

const HeroPromoteView = (props) => {
  const dispatch = useDispatch()
  const { visible, onCancel, formData } = props
  const [promoteLocation, setPromoteLocation] = useState('')
  const [current, setCurrent] = useState('')
  const { heroPromoteObj } = useSelector(
    (state) => ({
      heroPromoteObj: state.heroPromote.heroPromoteObj
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      if (formData && !isNil(formData) && !isEmpty(formData)) {
        await dispatch(fetchHeroPromoteDetail(formData.id))

        const res = await axios.get(
          'https://maps.googleapis.com/maps/api/geocode/json?latlng=' +
          formData.lat +
          ',' +
          formData.lng +
          '&key=AIzaSyBZbBLFNB3c9y3NpdDqwCaxUlUvNN9Fe7M'
        )
        if (
          !isNil(res.data) &&
          !isNil(res.data.results) &&
          !isEmpty(res.data.results)
        ) {
          setPromoteLocation(res.data.results[0].formatted_address)
        }
      }
    }
    fetch()
  }, [formData])

  const data = [
    {
      "promoteImage": formData.promoteImage,
      "material": formData.material
    },
  ]
  const handleClickImage = (e, image) => {
    e && e.preventDefault();
    setCurrent(image)
  };

  const handleCloseModal = e => {
    e && e.preventDefault();
    setCurrent('')
  };

  const materialColumns = [
    {
      title: 'รายการวัสดุ',
      dataIndex: 'material.name',
      key: 'materialName',
      render: (text) => (
        <span>
          <Avatar
            key={text + Math.random()}
            shape="square"
            src={formData.material.productImage}
            size={43}
            style={{ marginRight: 10 }}
          />
          {text}
        </span>
      )
    },
    {
      title: 'รูปถ่าย',
      dataIndex: 'promoteImage',
      align: 'right',
      key: 'binImage',
      render: (row) => (
        <div>
          <Avatar src={row} alt="" size={64} onClick={e => handleClickImage(e, row)} />
          {current && (
            <Lightbox mainSrc={current} onCloseRequest={handleCloseModal} />
          )}
        </div>
      )
    },
    {
      title: 'ปริมาณขั้นต่ำ',
      dataIndex: 'material.minQuantity',
      align: 'right',
      key: 'minQuantity',
      render: (row) => {
        switch (row) {
          case 'NO_LIMIT': {
            return 'ไม่จำกัด'
          }
          case 'UNIT_10': {
            return '> 10'
          }
          case 'UNIT_100': {
            return '> 100'
          }
          case 'UNIT_1000': {
            return '> 1000'
          }
          default: {
            return 'Not Specify'
          }
        }
      }
    },
    {
      title: 'หน่วย',
      align: 'right',
      key: 'unit',
      dataIndex: 'material.unit',
      render: (text) => <span>{text}</span>
    }
  ]
  const getHeroReason = (record) => {
    const reason1 = record.rejectReason1;
    const reason2 = record.rejectReason2;
    const reason3 = record.rejectReason3;
    const reason4 = record.rejectReason4;
    let reason = ''
    if (!isNull(reason1)) {
      reason = reason.concat(`${reason1}, `)
    }
    if (!isNull(reason2)) {
      reason = reason.concat(`${reason2}, `)
    }
    if (!isNull(reason3)) {
      reason = reason.concat(`${reason3}, `)
    }
    if (!isNull(reason4)) {
      reason = reason.concat(`${reason4} `)
    }
    return reason
  }

  const heroColumns = [
    {
      title: 'ฮีโร่ที่สนใจ',
      dataIndex: 'name',
      key: 'HeroName',
      render: (text, record) => (
        <span>
          <Avatar
            key={text}
            src={record.heroImage}
            size={40}
            style={{ marginRight: 10 }}
          />
          {text}
        </span>
      )
    },
    {
      title: 'ประเภทฮีโร่',
      dataIndex: 'heroType',
      key: 'heroType',
      render: (text) => (
        <span>{text ? HERO_TYPE_MESSAGE[text] : text}</span>
      )
    },
    {
      title: 'เสนอราคา',
      dataIndex: 'suggestPrice',
      key: 'suggestPrice',
      render: (text) => (
        <span>{text + ' บาท'}</span>
      )
    },
    {
      title: 'มีสินค้า',
      dataIndex: 'isAvailable',
      key: 'isAvailable',
      render: (row) => {
        switch (row) {
          case 'HAVE': {
            return 'มีอยู่'
          }
          case 'NOT_ENOUGH': {
            return 'ไม่พอ'
          }
          case 'SURE_HAVE': {
            return 'หาได้'
          }
          case 'NOT_SURE': {
            return 'ไม่แน่ใจ'
          }
          default: {
            return 'Not Specify'
          }
        }
      }
    }
  ]

  const heroReasonColumns = [
    {
      title: 'ฮีโร่ที่ไม่สนใจ',
      dataIndex: 'name',
      key: 'notHeroName',
      render: (text, record) => (
        <span>
          <Avatar
            key={text}
            src={record.heroImage}
            size={40}
            style={{ marginRight: 10 }}
          />
          {text}
        </span>
      )
    },
    {
      title: 'ประเภทฮีโร่',
      dataIndex: 'heroType',
      key: 'notHeroType',
      render: (text, record) => (
        <span>{text ? HERO_TYPE_MESSAGE[text] : text}</span>
      )
    },
    {
      title: 'เหตุผล',
      key: 'heroReason',
      render: (record) => (
        <span>{getHeroReason(record)}</span>
      )
    }
  ]

  return (
    <Modal
      width={1000}
      destroyOnClose={true}
      title={'รายละเอียดประกาศ'}
      visible={visible}
      onCancel={onCancel}
      footer={null}>
      <strong>สถานที่:</strong> {promoteLocation}{' '}
      <a
        href={
          'https://www.google.com/maps/search/?api=1&query=' +
          formData.lat +
          '%2C' +
          formData.lng
        }
        target="_blank"
        rel="noreferrer">
        <Icon type="eye" theme="filled" style={{ color: '#1890ff' }} />
      </a>
      <Table
        bordered
        dataSource={data}
        columns={materialColumns}
        size="small"
        rowKey={(record) => {
          return record.id
        }}
        style={{ marginTop: '20px' }}
        pagination={false}
      />
      <Table
        bordered
        dataSource={heroPromoteObj.interestedHero}
        columns={heroColumns}
        size="small"
        rowKey={(record) => {
          return record.id
        }}
        style={{ marginTop: '20px' }}
        pagination={false}
      />
      <Table
        bordered
        dataSource={heroPromoteObj.notInterestedHero}
        columns={heroReasonColumns}
        size="small"
        rowKey={(record) => {
          return record.id
        }}
        style={{ marginTop: '20px' }}
        pagination={false}
      />
    </Modal>
  )
}

HeroPromoteView.propTypes = {
  visible: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default HeroPromoteView



// WEBPACK FOOTER //
// ./src/pages/HeroPromote/HeroPromoteView/index.js